<div class="extranet-downloads">
  <h1>Downloads</h1>

  @if (isEditMode()) {
    Only visible for Admins:
    <a href="javascript:void()" onclick="$2sxc.cms.run(this, 'contentitems', { contentType: 'Download'}) ">Manage Downloads</a>
  }

  @if (downloadDataExtended()) {

    <!-- IntroductionDrivers -->
    <app-simple-download
      [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Driver)!"
      [items]="downloadDataExtended()?.IntroductionDrivers!"
      [title]="downloadCategory.Driver"
      [notesBefore]="getCategoryInfoByTitle(downloadCategory.Driver)!.IntroductionNotesBefore"
      [notesAfter]="getCategoryInfoByTitle(downloadCategory.Driver)!.IntroductionNotesAfter"
      />

    <!-- CurrentReleaseDrivers -->
     @if(downloadDataExtended()?.CurrentReleaseDrivers?.length) {
        <app-simple-download
        [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Driver)!"
        [items]="downloadDataExtended()?.CurrentReleaseDrivers!"
        [notesBefore]="getCategoryInfoByTitle(downloadCategory.Driver)!.CurrentReleaseNotesBefore"
        [notesAfter]="getCategoryInfoByTitle(downloadCategory.Driver)!.CurrentReleaseNotesAfter"
       />
      } 

    <!-- OlderReleaseDrivers -->
    @if(downloadDataExtended()?.OlderReleaseDrivers?.length) {
      <app-simple-download
      [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Driver)!"
      [items]="downloadDataExtended()?.OlderReleaseDrivers!"
      [notesBefore]="getCategoryInfoByTitle(downloadCategory.Driver)!.OlderReleasesNotesBefore"
      [notesAfter]="getCategoryInfoByTitle(downloadCategory.Driver)!.OlderReleasesNotesAfter"
      />
    }

    <!-- Get Info, if no Current Release or Older Release Drivers -->
    @if(downloadDataExtended()?.CurrentReleaseDrivers?.length == 0 && downloadDataExtended()?.OlderReleaseDrivers?.length == 0) {
      <div class="info-container">
        <span [innerHTML]="getCategoryInfoByTitle(downloadCategory.Driver)?.RenewSubscriptionInfo"></span>
      </div>
    }

    <!-- Components  -->
    <app-components 
    [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Component)!" 
    [components]="downloadDataExtended()?.Components!"/>

    <!-- Software  -->
    <app-software 
    [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Software)!" 
    [items]="downloadDataExtended()?.Software!"/>

    <!-- Support  -->
    <app-simple-download 
    [categoryInfo]="getCategoryInfoByTitle(downloadCategory.Support)!" 
    [items]="downloadDataExtended()?.Support!" 
    [title]="downloadCategory.Support"
    [notesBefore]="getCategoryInfoByTitle(downloadCategory.Support)!.NotesBefore"
    [notesAfter]="getCategoryInfoByTitle(downloadCategory.Support)!.NotesAfter"
    />

    <!-- Legacy Drivers  -->
    <app-legacy-driver 
    [categoryInfo]="getCategoryInfoByTitle(downloadCategory.LegacyDriver)!" 
    [items]="downloadDataExtended()?.LegacyDrivers!" 
    [title]="downloadCategory.LegacyDriver"/>

  } @else {
    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>